import React from "react";
import ErrorView from "./errorView";

const DedicatedErrorPage = ({ error }) => {
  const handleReload = () => {
    // window.location.href = "/";
      window.history.back();
  };

  console.log("error", error);

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", background: "hsl(var(--bg))" }}>
      <ErrorView error={error} />
      <button
        onClick={handleReload}
        style={{
          marginTop: "2rem",
          padding: "0.75rem 2rem",
          fontSize: "1.1rem",
          background: "hsl(var(--primary))",
          color: "hsl(var(--text-inverse))",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
        }}
      >
        Reload App
      </button>
    </div>
  );
};

export default DedicatedErrorPage; 